module.exports = __webpack_public_path__ + "img/book_1248.2cd56842.png";